const Images = {
    flashDeal: require('../assets/images/FlashDealB.png'),
    flashDeal2: require('../assets/images/FlashDealB2.jpg')
}

export default Images;